import moment from "moment";
import "moment/locale/fr";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import swal from "sweetalert";
import { API } from "../constants/env";
import {
  DetailsCard,
  DetailsHeader,
  DetailsBadge,
  DetailsTitle,
  DetailsLabel,
  DetailsText,
  BackButton,
} from "../styles/Homeworks";

const HomeworkDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const history = useHistory();
  // Venant de la liste, le devoir est déjà chargé ; sinon (lien direct,
  // rafraîchissement) on le récupère par son id.
  const [homework, setHomework] = useState(location.state?.homework || null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (homework) return;
    fetch(API.homework.info(id), {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-auth-token": localStorage.getItem("token"),
      },
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.error) {
          return setNotFound(true);
        }
        setHomework(response);
      })
      .catch((e) => {
        setNotFound(true);
        if (e.message === "Failed to fetch") {
          swal("Erreur", "Probléme de connection", "error");
        }
      });
  }, [id, homework]);

  const goBack = () => {
    // Retour à la liste à l'entrée d'historique d'origine (garde le mois affiché)
    if (location.state?.homework) {
      history.goBack();
    } else {
      history.replace("/homeworks");
    }
  };

  const renderContent = () => {
    if (notFound) {
      return <DetailsText>Devoir introuvable.</DetailsText>;
    }
    if (!homework) {
      return <DetailsText>Chargement...</DetailsText>;
    }
    const { title, description, deadline, subject, created_at } = homework;
    return (
      <React.Fragment>
        <DetailsHeader>
          <DetailsBadge>
            {(subject?.name || "").slice(0, 2).toUpperCase()}
          </DetailsBadge>
          <DetailsTitle dir="auto">{title}</DetailsTitle>
        </DetailsHeader>

        <DetailsLabel>Matière</DetailsLabel>
        <DetailsText dir="auto">{subject?.name}</DetailsText>

        <DetailsLabel>À rendre pour le</DetailsLabel>
        <DetailsText>{moment(deadline).format("dddd D MMMM YYYY")}</DetailsText>

        <DetailsLabel>Description</DetailsLabel>
        <DetailsText dir="auto">
          {description || "Pas de description."}
        </DetailsText>

        {created_at && (
          <React.Fragment>
            <DetailsLabel>Publié le</DetailsLabel>
            <DetailsText>
              {moment(created_at).format("D MMMM YYYY")}
            </DetailsText>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };

  return (
    <div style={{ padding: 15 }}>
      <BackButton onClick={goBack}>← Retour</BackButton>
      <DetailsCard>{renderContent()}</DetailsCard>
    </div>
  );
};

export default HomeworkDetails;
